import React from "react";
import { EvlTeacherInfoProps } from "../../../../../../API/evaluate";
import Style from "./index.module.scss";

interface Props {
    children: React.ReactElement;
    data: EvlTeacherInfoProps;
}
export default function TeacherItem({ data, children }: Props) {
    return (
        <dl className={Style.teacherRow} key={data.id}>
            <dt>
                <h1>
                    {data.courseName} : {data.teacherName}
                </h1>
                <h2>
                    {data.courseNo} / {data.courseSeq}
                </h2>
            </dt>
            <dd>{children}</dd>
        </dl>
    );
}
